ApiAjax = require 'network/api-ajax'
WarningBannerView = require 'views/header/warning-banner-view'
templates = require 'views/internal/templates'

module.exports = class ConfirmEmailBannerView extends WarningBannerView

  initialize: ->
    knownEmailProviders =
      gmail: /@(gmail|googlemail).com$/
      yahoo: /@(yahoo|ymail).com$/
      live: /@(hotmail|live).com$/
      mac: /@(me|mac).com$/

    emailProviderInboxes =
      gmail: 'http://gmail.com'
      yahoo: 'http://mail.yahoo.com'
      live: 'http://live.com'
      mac: 'https://www.icloud.com/'

    for key, matcher of knownEmailProviders
      if matcher.test(@model.get('email'))
        @emailInboxUrl = emailProviderInboxes[key]
        break

    if !@emailInboxUrl?
      ApiAjax
        url: '/checkYourEmail'
        data: { email: @model.get('email') }
        dataType: 'json'
        success: (data) =>
          if data.error?
            return
          @emailInboxUrl = data.url
          @render()

  render: ->
    data = @model.toJSON()

    if @emailInboxUrl?
      data.emailInboxUrl = @emailInboxUrl
      data.knownEmailProvider = true

    @$el.html(
      templates.fill(
        'header_warning_banner',
        data
      )
    )

    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/confirm-email-banner-view.coffee